// Colorscale interpolation + CSS gradient previews. Stops are
// [position 0..1, [r, g, b]] arrays (see wxchange-config.js).

export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export const lerp = (a, b, t) => a + (b - a) * t;

export function interpCS(stops, t) {
  t = clamp(t, 0, 1);
  for (let i = 0; i < stops.length - 1; i++) {
    const [p0, c0] = stops[i], [p1, c1] = stops[i + 1];
    if (t >= p0 && t <= p1) {
      const f = p1 === p0 ? 0 : (t - p0) / (p1 - p0);
      return [
        Math.round(lerp(c0[0], c1[0], f)),
        Math.round(lerp(c0[1], c1[1], f)),
        Math.round(lerp(c0[2], c1[2], f)),
      ];
    }
  }
  return stops[stops.length - 1][1];
}

/**
 * 256-entry RGB lookup table for a colorscale's stops. recolorRealTile calls
 * interpCS once per pixel -- 65,536 times per 256x256 tile, every tile,
 * every pan/zoom -- and interpCS itself linearly scans the stops array each
 * time. Quantizing to 256 buckets and precomputing every bucket once turns
 * that into an O(1) array lookup per pixel instead of an O(stops) scan.
 */
export function buildColorLUT(stops) {
  const lut = new Uint8ClampedArray(256 * 3);
  for (let i = 0; i < 256; i++) {
    const c = interpCS(stops, i / 255);
    lut[i * 3] = c[0]; lut[i * 3 + 1] = c[1]; lut[i * 3 + 2] = c[2];
  }
  return lut;
}

export function cssGradient(colorscales, csId, lo, hi) {
  const cs = colorscales[csId];
  if (!cs) return "var(--bg-sunken)";
  lo = lo == null ? 0 : lo;
  hi = hi == null ? 1 : hi;
  const stops = [];
  for (let i = 0; i <= 10; i++) {
    const t = i / 10;
    const c = interpCS(cs.stops, lo + t * (hi - lo));
    stops.push(`rgb(${c[0]},${c[1]},${c[2]}) ${Math.round(t * 100)}%`);
  }
  return `linear-gradient(90deg, ${stops.join(",")})`;
}
